import React from 'react';

export default props => (
  <svg viewBox={props.viewBox || '0 0 25 25'} style={{ display: 'block', margin: '0 auto' }}>
    <g fill={props.color}>
      <path d="M17.3,0H8.1C6.9,0,6,0.9,6,2.1v20.8C6,24.1,6.9,25,8.1,25h9.2c1.1,0,2.1-0.9,2.1-2V2.1C19.4,0.9,18.4,0,17.3,0z M11.7,2h1.9 c0.2,0,0.3,0.2,0.3,0.4c0,0.2-0.1,0.4-0.3,0.4h-1.9c-0.2,0-0.3-0.2-0.3-0.4C11.4,2.2,11.5,2,11.7,2z M12.7,23.9 c-0.8,0-1.4-0.6-1.4-1.4s0.6-1.4,1.4-1.4s1.4,0.6,1.4,1.4S13.5,23.9,12.7,23.9z M17,19.6H8.4v-15H17V19.6z" />
    </g>
  </svg>
);
